export const OAUTH_REDIRECT_URL = `${window.location.protocol}//${window.location.host}/oauth-sync`;
